import React, { useEffect } from 'react';
import PageLayout from '../components/templates/PageLayout';
import FeaturedArticle from '../components/molecules/FeaturedArticle';
import {
  BLOG_NOTION_INDEX_URL,
  NEW_TAB_NOTE,
  featuredBlogArticles,
  otherBlogArticles,
} from '../data/blogArticles';

const Blog = () => {
  useEffect(() => {
    document.title = 'Blog | DataRook';
  }, []);

  return (
    <PageLayout>
      <div className="dr-container py-16">
        <h1 className="text-4xl font-black mb-4 text-center text-navy">Soccer Analytics Blog</h1>
        <p className="text-lg text-gray-700 text-center max-w-3xl mx-auto mb-4">
          Data-backed soccer stories for families, coaches, and students — from World Cup 2026
          reads to One Knoxville SC analysis, powered by Twelve Football.
        </p>
        <p className="text-sm text-gray-600 text-center max-w-2xl mx-auto mb-10">{NEW_TAB_NOTE}</p>

        <p className="text-center mb-12">
          <a
            href={BLOG_NOTION_INDEX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow font-semibold"
          >
            Browse the full blog on Notion
          </a>
        </p>

        {featuredBlogArticles.map((article) => (
          <div key={article.id} className="mb-12 max-w-4xl mx-auto">
            <FeaturedArticle
              title={article.title}
              excerpt={article.excerpt}
              link={article.link}
              date={article.date}
              featured
            />
          </div>
        ))}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {otherBlogArticles.map((article) => (
            <FeaturedArticle
              key={article.id}
              title={article.title}
              excerpt={article.excerpt}
              link={article.link}
              date={article.date}
            />
          ))}
        </div>
      </div>
    </PageLayout>
  );
};

export default Blog;
